import { React, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, CloseRoundedIcon, Box } from '../../utils/globalImports';
import { CustomButton } from '../../utils/globalImports';

interface CustomConfirmDialogProps {
    open: boolean;                    // Controls whether the dialog is open
    title?: string;                    // The title of the dialog
    message?: string;                  // The message in the dialog
    onConfirm: () => void;            // Callback for confirm action
    onCancel: () => void;             // Callback for cancel action
    onClose: () => void;              // Close the dialog without confirming
    confirmLabel?: string;           // Optional label for the confirm button
    cancelLabel?: string;            // Optional label for the cancel button
}

const dialogTextStyles: React.CSSProperties = {
    fontSize: '18px',
    textAlign: 'center',
    color: '#8c8c8c',
    lineHeight: '1.5',
    padding: '40px'
};

const dialogTitleStyles: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 500,
    padding: '0px 0px 20px 0px',
    textAlign: 'center',
    color: '#1e66ab',
};

const CustomConfirmDialog: React.FC<CustomConfirmDialogProps> = ({
    open,
    title,
    message,
    onConfirm,
    onCancel,
    onClose,
    confirmLabel = 'OK',
    cancelLabel = 'Cancel',
}) => {
    const isCustomConfirmLabel = !!confirmLabel;
    const isCustomCancelLabel = !!cancelLabel;
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            sx={{
                '& .MuiPaper-root': {
                    borderRadius: '25px',
                    padding: '25px',
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center',
                },
            }}
        >
            <IconButton
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    top: '20px',
                    right: '16px',
                    color: '#1e66ab',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    '& .MuiSvgIcon-root': {
                        fontSize: '20px',

                    },
                    '&:hover': {
                        color: '#8c8c8c',
                    },
                }}
            >
                <CloseRoundedIcon />
            </IconButton>

            <DialogTitle sx={{ ...dialogTitleStyles }}>{title}</DialogTitle>
            <Divider sx={{ width: "114.6%", marginLeft: "-10%", marginRight: "-10%" }} />
            <Box
                sx={{
                    maxHeight: '150px',  // Adjust the height as needed
                    overflowY: 'auto'
                }}
            >
                <DialogContent
                    sx={{
                        ...dialogTextStyles,
                        whiteSpace: 'pre-line',
                    }}
                >
                    {message}
                </DialogContent>
            </Box>
            <Divider sx={{ width: "114.6%", marginLeft: "-10%", marginRight: "-10%" }} />
            
            <DialogActions
                sx={{
                    justifyContent: 'center',
                    gap: '16px',
                }}
            >
                <CustomButton
                    onClick={onCancel}
                    backgroundColor="#ffffff"
                    hoverColor="#2269ad"
                    sx={{
                        top: '10px',
                        minWidth: '30%',
                        width: 'fit-content',
                        color: '#96c121',
                        border: '2px solid #96c121',
                        '&:hover': {
                            color: '#fff',
                        },
                    }}
                    capsule
                >
                    {cancelLabel}
                </CustomButton>

                <CustomButton
                    onClick={onConfirm}
                    backgroundColor="#a3c63d"
                    sx={{ top: '10px', minWidth:'30%', width: 'fit-content' }}
                    hoverColor="#2269ad"
                    capsule
                >
                    {confirmLabel}
                </CustomButton>
            </DialogActions>

        </Dialog>
    );
};

export default CustomConfirmDialog;
